const SCRIPT_URL = 'https://ha.harryonline.net/ha.js';
const WEBSITE_ID = '52544fdb-c765-422b-9739-11fea5716ebe';

// eslint-disable-next-line func-names
(function() {
  const script = document.createElement('script');
  script.src = SCRIPT_URL;
  script.dataset.websiteId = WEBSITE_ID;
  script.async = true;
  document.head.appendChild(script);
})();

window.haQ = window.haQ || [];

function haTrack(...args) {
  const timestamp = Math.floor(Date.now() / 1000);
  window.haQ.push([timestamp, ...args]);
}

export default haTrack;
